module.exports = __webpack_public_path__ + "img/BG-2.99e63b0e.png";